<script>
import checkoutCart from '~/mixins/checkoutCart.vue'

export default {
  name: 'CheckoutCart',
  serverCacheKey() {
    return false
  },
  mixins: [checkoutCart]
}
</script>
